import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customize-solutions',
  templateUrl: './customize-solutions.component.html',
  styleUrls: ['./customize-solutions.component.css']
})
export class CustomizeSolutionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
